import React from "react";
import { useTranslation } from "react-i18next";
import i18n, { SUPPORTED_LANGS, LANG_LABELS } from "../i18n";
import { Globe } from "lucide-react";

export default function LanguageSelector() {
  const { t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

  return (
    <div className="mt-6 rounded-xl border border-slate-800 bg-slate-900/50 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-500/20">
          <Globe className="w-5 h-5 text-blue-400" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-white">{t("settings.language_title")}</h2>
          <p className="text-sm text-slate-400">{t("settings.language_help")}</p>
        </div>
      </div>

      <select
        className="w-full p-3 rounded-lg bg-slate-800/50 border border-slate-700 text-white focus:outline-none focus:ring-2 focus:ring-rose-500/30 focus:border-rose-500/50 transition cursor-pointer"
        value={current}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
      >
        {SUPPORTED_LANGS.map((lng) => (
          <option key={lng} value={lng}>
            {LANG_LABELS[lng] || lng}
          </option>
        ))}
      </select>
    </div>
  );
}
